import React, { useRef } from 'react';
import {
  IonItemSliding,
  IonItem,
  IonLabel,
} from '@ionic/react';
import { Inspection } from '../models/Inspection';

interface InspectionListItemProps {
  inspection: Inspection;
}

const InspectionListItem: React.FC<InspectionListItemProps> = ({
  inspection,
}) => {
  const ionItemSlidingRef = useRef<HTMLIonItemSlidingElement>(null);

  return (
    <IonItemSliding
      ref={ionItemSlidingRef}
      class={'track-' + inspection.jan.toLowerCase()}
    >
      <IonItem>
        <IonLabel>
          <h3 style={{ fontSize: '20px' }}>
            商品コード : {(inspection.jan !== "" && inspection.original_num !== "") ? `${inspection.jan} - ${inspection.original_num}` : inspection.jan + inspection.original_num}
          </h3>
          <p style={{ fontSize: '20px', lineHeight: '30px' }}>
            注文日 : {inspection.order_date},
            数量 : {inspection.quantity},
            注文番号 : {inspection.order_num}
	          {(inspection.status === 1) ? " 検品完了" : ""}
          </p>
        </IonLabel>
      </IonItem>
    </IonItemSliding>
  );
};

export default React.memo(InspectionListItem);
